import { requestGetJSON } from '../../../NonReact/common/API/REST/RESTAPIClient'
import { getAPIKeyURL } from '../../../NonReact/constants/ApiConstants'
import { displayError } from '../Utils/Messages'
import { APIKeyPOST, APIKeysInfo, APIKeysInfoBackend, APIKeyStatus } from '../../AddUser/Types'
import { requestJSON } from '../../../NonReact/common/API/REST/RESTClient'
import { RESTMethods } from '../../../NonReact/constants/REST'
import { $error } from '../Utils/ConsoleUtils'
import { EMPTY_STRING } from '../../../NonReact/constants/Common'
import { APIData, APIListData, JSONResponse } from '../../../NonReact/common/Types/Types'

export const handleError = (e: Error): undefined => {
    displayError(e)
    return undefined
}

const apiKeyMapper = (apiKey: JSONResponse<APIKeysInfoBackend>): APIKeysInfo => ({
    id: apiKey?.ID,
    name: apiKey?.Name ?? EMPTY_STRING,
    status: apiKey?.Status ?? APIKeyStatus.ACTIVE,
    dateTimeExpiry: apiKey?.DateTimeExpiry,
    dateTimeCreated: apiKey?.DateTimeCreated,
    dateTimeLastUsed: apiKey?.DateTimeLastUsed,
    apiKey: apiKey?.APIKey
})

export const getAPIKeysForUser = (username: string): Promise<JSONResponse<APIKeysInfo[]>> =>
    requestGetJSON<APIListData<APIKeysInfoBackend>>(getAPIKeyURL(username))
        .then(
            (response: JSONResponse<APIListData<APIKeysInfoBackend>>): JSONResponse<APIKeysInfo[]> =>
                response?.Data?.Items?.map(apiKeyMapper)
        )
        .catch((e: Error): undefined => {
            $error(e)
            return undefined
        })

export const createAPIKeyForUser = (username: string, apiKey: APIKeyPOST): Promise<JSONResponse<APIKeysInfo>> =>
    requestJSON<APIData<APIKeysInfoBackend>>(getAPIKeyURL(username), {
        method: RESTMethods.POST,
        body: apiKey
    })
        .then(
            (response: JSONResponse<APIData<APIKeysInfoBackend>>): JSONResponse<APIKeysInfo> =>
                apiKeyMapper(response?.Data)
        )
        .catch(handleError)

export const updateAPIKeyForUser = (
    username: string,
    apiKeyID: string,
    apiKey: Partial<APIKeysInfo>
): Promise<JSONResponse<APIKeysInfo>> =>
    requestJSON<APIKeysInfo>(getAPIKeyURL(username, apiKeyID), {
        method: RESTMethods.PUT,
        body: apiKey
    }).catch(handleError)

export const deleteAPIKeyForUser = (username: string, apiKeyID: string): Promise<JSONResponse<void>> =>
    requestJSON<void>(getAPIKeyURL(username, apiKeyID), {
        method: RESTMethods.DELETE
    }).catch(handleError)
